(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    $('.footer_list a').click(function() {
        trackEvent('BM FooterLink Clicked')
    })
    $('.footer .social-icons a').click(function() {
        trackEvent('BM FooterSocialLink Clicked')
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-bundle-and-save"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const SLIDE_SELECTOR = '.bundle-item'
        const SLIDER_SELECTOR = '.bundle-and-save__content'
        const LEFT_ARROW_SELECTOR = '.bundle-and-save__arrow--left'
        const RIGHT_ARROW_SELECTOR = '.bundle-and-save__arrow--right'
        const SEE_ALL_SELECTOR = '.bundle-and-save__see-all'
        const ARROW_HIDDEN_CLASS = 'bundle-and-save__arrow--hidden'

        const columnGap = 24
        const slideWidth = document.querySelector(SLIDE_SELECTOR).clientWidth + columnGap
        const maxOffsetSlides = document.querySelectorAll(SLIDE_SELECTOR).length - 1

        let offsetSlides = 0

        const moveToOffset = (offset) => {
            document.querySelector(SLIDER_SELECTOR).style.marginLeft = `${0 - offset * slideWidth}px`

            if (!offsetSlides) {
                document.querySelector(LEFT_ARROW_SELECTOR).classList.add(ARROW_HIDDEN_CLASS)
            } else {
                document.querySelector(LEFT_ARROW_SELECTOR).classList.remove(ARROW_HIDDEN_CLASS)
            }

            if (offsetSlides === maxOffsetSlides) {
                document.querySelector(RIGHT_ARROW_SELECTOR).classList.add(ARROW_HIDDEN_CLASS)
            } else {
                document.querySelector(RIGHT_ARROW_SELECTOR).classList.remove(ARROW_HIDDEN_CLASS)
            }
        }

        const moveLeft = () => {
            const canMove = offsetSlides > 0
            canMove && moveToOffset(--offsetSlides)
        }

        const moveRight = () => {
            const canMove = offsetSlides < maxOffsetSlides
            canMove && moveToOffset(++offsetSlides)
        }

        document.querySelector(LEFT_ARROW_SELECTOR).addEventListener('click', moveLeft)
        document.querySelector(RIGHT_ARROW_SELECTOR).addEventListener('click', moveRight)

        moveToOffset(0)

        // tracking

        document.querySelectorAll(SLIDE_SELECTOR).forEach((bundleLink) => {
            bundleLink.addEventListener('click', () => mixpanel.track('Redesign Bundle Product Clicked'))
        })

        document.querySelector(SEE_ALL_SELECTOR).addEventListener('click', () => mixpanel.track('Redesign Bundle CTA clicked'))
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-row-slides"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.row-slides-item__button').forEach((bundleLink) => {
        bundleLink.addEventListener('click', () => mixpanel.track('Home Page titles CTA button clicked'))
    })
  })

  } catch(e) { console.error(e); }
})();
})();
